import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import s from './OrganisationRegion.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

const OrganisationRegionListTable = ({
  OrganisationRegionData = [],
  RemoveOrganisationRegion,
  ChangeOrganisationRegion,
  UpdateAllowed,
  DeleteAllowed,
  intl
}) => {
  return (
    <div>
      <Table variant className={s.wsInnerTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="common.name" defaultMessage="Name" />
            </th>
            <th>
              <FormattedMessage id="common.description" defaultMessage="Description" />
            </th>
            {(UpdateAllowed || DeleteAllowed) && <th></th>}
          </tr>
        </thead>
        <tbody>
          {OrganisationRegionData.map((n, index) => {
            return (
              <Fragment key={index}>
                <tr data-unittest="OrganisationRegionData">
                  <td>{n.Name}</td>
                  <td>{n.Description}</td>
                  {(UpdateAllowed || DeleteAllowed) && (
                    <td className={s.btnCol}>
                      {UpdateAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.changeButton}
                          href="#"
                          onClick={() => {
                            ChangeOrganisationRegion(n.OrganisationRegionId);
                          }}
                          data-unittest="changeData"
                        >
                          <FormattedMessage id="common.edit" defaultMessage="EDIT" />
                        </Button>
                      )}
                      {DeleteAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.removeButton}
                          href="#"
                          onClick={() => {
                            RemoveOrganisationRegion(n.OrganisationRegionId);
                          }}
                          data-unittest="removeData"
                        >
                          <FormattedMessage id="common.remove" defaultMessage="REMOVE" />
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
              </Fragment>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};


OrganisationRegionListTable.propTypes = {
  OrganisationRegionData: PropTypes.array.isRequired,
  RemoveOrganisationRegion: PropTypes.func.isRequired,
  ChangeOrganisationRegion: PropTypes.func.isRequired,
  UpdateAllowed: PropTypes.bool,
  DeleteAllowed: PropTypes.bool
};

export default injectIntl(OrganisationRegionListTable);
